import { Fragment, h } from '@stencil/core';
import { EnvironmentSubgroup } from './environment-subgroup';
export const EnvironmentalGroup = (group) => {
  const { parentGroupname, subGroups } = group || {};
  return h(Fragment, null, parentGroupname && h("div", { class: "envsection_row" }, h("div", { class: "envsection_cell envsection_groupname" }, parentGroupname)), subGroups === null || subGroups === void 0 ? void 0 :
    subGroups.map((envSubgroup) => h(EnvironmentSubgroup, Object.assign({}, envSubgroup))));
};
